import { ROUTE_PATHS } from '~/app/router/routes'
import { Icon, type IconName } from '~/shared/ui'

export type TabConfig = {
  key: string
  path: string
  label: string
  icon: IconName
}

// Порядок, подписи и иконки — спека 03 §1. Реестр ~/shared/ui/Icon уже содержит
// ровно эти пять имён под таб-бар.
export const TABS: TabConfig[] = [
  { key: 'home', path: ROUTE_PATHS.home, label: 'Главная', icon: 'home' },
  { key: 'compat', path: ROUTE_PATHS.compat, label: 'Совместимость', icon: 'heart' },
  { key: 'links', path: ROUTE_PATHS.links, label: 'Узы', icon: 'links' },
  { key: 'stats', path: ROUTE_PATHS.stats, label: 'Статистика', icon: 'stats' },
  { key: 'profile', path: ROUTE_PATHS.profile, label: 'Профиль', icon: 'profile' },
]

// Таб-бар из спеки 01 §5: иконки 21px, stroke-width 1.6.
export function renderTabIcon(name: IconName) {
  return <Icon name={name} size={21} strokeWidth={1.6} />
}
